import React, { useContext } from 'react';
import { Form, Input, Button, Space } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { AuthContext } from '../../AuthContext';
import styles from './index.module.css';
import { login } from '../../api';
import Logo from '../../images/logo.png';

const LoginForm: React.FC = () => {
    const authContext = useContext(AuthContext);
    const { setLoggedIn } = authContext || {};

    const onFinish = async (values: any) => {
        console.log('Received values of form: ', values);
        const response = await login(values.username, values.password);
        if (response.status === 200) {
            const result = await response.json();
            if (setLoggedIn && result.success) {
                console.log('Login success');
                setLoggedIn(true); // log the user in when the form is submitted
            }
            else {
                console.log('Login failed');
            }
        }
        else {
            console.log('Login failed');
        }
    };

    return (
        <div className={styles.container}>
            <Form
                name="normal_login"
                className="login-form"
                initialValues={{ remember: true }}
                onFinish={onFinish}
            >
                <h1 style={{ 
                    textAlign: 'center',
                    fontSize: '28px',
                    fontWeight: '700',
                    marginBottom: '8px',
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    WebkitBackgroundClip: 'text'
                }}>Tour Fast 報團快</h1>
                <img src={Logo} alt="Logo" height={280} width={280} style={{ marginBottom: '24px', display: 'block', margin: '0 auto 24px' }}/>
                <Form.Item
                    name="username"
                    rules={[{ required: true, message: '請輸入用戶名稱!' }]}
                >
                    <Input 
                        prefix={<UserOutlined style={{ color: '#667eea' }} />} 
                        placeholder="用戶名稱"
                        size="large"
                        style={{ fontSize: '15px' }}
                    />
                </Form.Item>
                <Form.Item
                    name="password"
                    rules={[{ required: true, message: '請輸入密碼!' }]}
                >
                    <Input.Password
                        prefix={<LockOutlined style={{ color: '#667eea' }} />}
                        type="password"
                        placeholder="密碼"
                        size="large"
                        style={{ fontSize: '15px' }}
                    />
                </Form.Item>

                <Form.Item>
                    <Button 
                        type="primary" 
                        htmlType="submit" 
                        className="login-form-button" 
                        style={{ 
                            width: '100%',
                            height: '44px',
                            fontSize: '16px',
                            fontWeight: '600',
                            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                            border: 'none',
                            boxShadow: '0 4px 12px rgba(102, 126, 234, 0.4)',
                        }}
                    >
                        登入
                    </Button>
                </Form.Item>
            </Form>
        </div>
    );
};

export default LoginForm;